interface Props {
  activeColor: string;
  bgColor?: string;
}

const LeadHistoryIcon = ({ activeColor, bgColor }: Props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 12C17.4 12 12 17.4 12 24C12 30.6 17.4 36 24 36C30.6 36 36 30.6 36 24C36 17.4 30.6 12 24 12Z"
        stroke="#234cfc"
        strokeWidth="2"
      />

      <path
        d="M24 18V24L28 26"
        stroke="#234cfc"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M16 14H12V18"
        stroke="#234cfc"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LeadHistoryIcon;
